// Client-side validators. Mirror the stricter server-side checks in
// netlify/lib/validate.ts but kept separate to avoid bundling Node code.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(s: string): boolean {
  return EMAIL_RE.test(s.trim());
}

export function normalizePhone(s: string): string {
  // Strip everything except digits and a leading +.
  return s.replace(/(?!^\+)[^\d]/g, '');
}

export function isValidPhone(s: string): boolean {
  const n = normalizePhone(s);
  // 7–15 digits per ITU E.164. Optional leading +.
  return /^\+?\d{7,15}$/.test(n);
}
